import React from 'react';
import AttendeesListContainer from '../attendees-list-container/attendees-list-container';
import ActiveAttendeesCountContainer from '../active-attendees-count-container/active-attendees-count-container';

const AttendeesContainer = (): JSX.Element => (
  <section className='attendees-page-container'>
    <AttendeesListContainer/>
    <ActiveAttendeesCountContainer/>
  </section>
);

export default AttendeesContainer;